import { Perpetrator } from 'src/api';
import { Evidence } from 'src/reducers/ManualCase';
import { MCCEventType, UploadScanStatus } from 'src/types';

type FileValue = {
  id: string;
  path: string;
  scanStatus?: UploadScanStatus;
};

export const mapEvidenceToMCCEvent = (
  evidence: Evidence[],
  eventID: string,
  created?: string,
  updated?: string,
): MCCEventType => {
  const relevantEvidence = evidence.filter((value) => value.event === eventID);
  const date = filterEvidence(relevantEvidence, '@evidence/date');
  const description = filterEvidence(relevantEvidence, '@evidence/description');
  const emotion = filterEvidence(relevantEvidence, '@evidence/emotion');
  const location = filterEvidence(relevantEvidence, '@evidence/location');
  const perpetrators = relevantEvidence.filter(
    (value) => value.type === '@evidence/perpetrator',
  );
  const files = relevantEvidence.filter(
    (value) => value.type === '@evidence/photo',
  );
  const time = filterEvidence(relevantEvidence, '@evidence/time');
  const witness = filterEvidence(relevantEvidence, '@evidence/witness');
  const now = new Date().toISOString();
  return {
    date: date.value
      ? {
          value: date.value as string,
          created: date.created,
          updated: date.updated,
        }
      : { value: '', created: now, updated: now },
    description: description.value
      ? {
          value: String(description.value),
          created: description.created,
          updated: description.updated,
        }
      : { value: '', created: now, updated: now },
    emotion: emotion.value
      ? {
          value: String(emotion.value),
          created: emotion.created,
          updated: emotion.updated,
        }
      : { value: '', created: now, updated: now },
    location: location.value
      ? {
          value: String(location.value),
          created: location.created,
          updated: location.updated,
        }
      : { value: '', created: now, updated: now },
    perpetrators: perpetrators.map((perpetrator) => ({
      external: (perpetrator.value as Perpetrator).external,
      id: (perpetrator.value as Perpetrator).id,
      name: (perpetrator.value as Perpetrator).name,
      created: perpetrator.created,
      updated: perpetrator.updated,
    })),
    files: files.map((file) => ({
      id: (file.value as FileValue).id
        ? String((file.value as FileValue).id)
        : String(file.value),
      created: file.created,
      updated: file.updated,
      path: (file.value as FileValue).path,
      status: (file.value as FileValue).scanStatus ?? null,
    })),
    time: time.value
      ? {
          value: String(time.value),
          created: time.created,
          updated: time.updated,
        }
      : { value: '', created: now, updated: now },
    witness: witness.value
      ? {
          value: String(witness.value),
          created: witness.created,
          updated: witness.updated,
        }
      : { value: '', created: now, updated: now },
    id: eventID,
    created,
    updated,
  };
};

const filterEvidence = (evidence: Evidence[], type: string) => {
  const filtered = evidence.filter((e) => e.type === type);
  if (filtered.length === 0) {
    return { value: null };
  }
  if (filtered.length > 1) {
    throw new Error(`Error: Multiple ${type} found for single event`);
  }
  return filtered[0];
};
